/**
 * QuoteHeader — Top section of the Quote Builder.
 *
 * PR-3 (2026-07-20) — SHRUNK. The customer section (search + contact card +
 * addresses + salespeople + lead source) now lives in <CustomerBlock />
 * (`./CustomerBlock.js`). QuoteHeader retains only:
 *   • Customer block
 *   • Auto-expire helper text
 *
 * PT-10: Job Type / Payment Terms / Payment Type dropdowns removed.
 * Payment term + type are seeded from the customer record; Job Type is not
 * a requirement (only customer_type and work_order_type matter).
 */

import React, { useMemo } from 'react';
import CustomerBlock from './CustomerBlock';
import {
  expiryHelperText,
  checkExpiry,
} from '../../../quote-builder';

// ─── Component ───────────────────────────────────────────────────────────────

export default function QuoteHeader({
  prefill,
  onPrefillChange,
  dealerDefaultPaymentTerm,
  // metadata and onMetadataChange retained in signature for backward-compat
  // but no longer consumed (PT-10: Job/Payment/Term row removed).
  // eslint-disable-next-line no-unused-vars
  metadata,
  // eslint-disable-next-line no-unused-vars
  onMetadataChange,
  // eslint-disable-next-line no-unused-vars
  salespersonOptions = [],
  validityDays = 30,
  createdAt,
}) {
  // ─── Expiry ──────────────────────────────────────────────────────────────
  const expiry = useMemo(
    () => checkExpiry(createdAt, validityDays, 'active'),
    [createdAt, validityDays]
  );

  // ─── Render ──────────────────────────────────────────────────────────────
  return (
    <div className="space-y-6">
      {/* Customer section — now delegated to CustomerBlock (PR-3). */}
      <CustomerBlock
        prefill={prefill}
        onPrefillChange={onPrefillChange}
        dealerDefaultPaymentTerm={dealerDefaultPaymentTerm}
      />

      {/* Expiry helper text */}
      {createdAt && expiry.daysRemaining < Infinity && (
        <p className="text-xs" style={{ color: 'var(--color-text-secondary)' }}>
          {expiryHelperText(expiry.daysRemaining)}
        </p>
      )}
    </div>
  );
}
